import { Card, Typography } from "antd";
import React from "react";
import { CasesSendReportCaseSummaryContainerFileInfoFieldsFragment, CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFieldsFragment, ArchivedCaseSummaryActivityLog, FileInfo, CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsFieldsFragment } from "../../../../../../generated";
import { Country } from "../../../../../../types/country";
import { ActivityLogLite } from "../../../../../shared/activitylog-lite/activity-log-lite";
import { FilesSummary } from "../../../../../shared/display-files/files-summary";
import { TransactionData, TransactionsLite } from "../../../../../shared/transactions/transactions-lite";
import { ApplicantDetailsSummary } from "./applicant-details-summary";
import { AffirmationsSummary } from "./affirmations-summary";

interface SummaryProps {
  caseDetailsData: CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsFieldsFragment;
  fileDetails: CasesSendReportCaseSummaryContainerFileInfoFieldsFragment[];
  privateCaseDetails: CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFieldsFragment;
  countryData: Country[];
  transactionData: TransactionData;
  activityData: ArchivedCaseSummaryActivityLog[];
  additionalFiles: FileInfo[];
}

export const Summary: React.FC<SummaryProps> = (props) => {
  return (
    <div className="flex flex-col space-y-4">
      <div>
        <ApplicantDetailsSummary
          applicationDetails={props.caseDetailsData?.application}
        />
        <br />
        <FilesSummary fileDetails={props.fileDetails} />
        <br />
        <AffirmationsSummary
          caseApplicationReviewData={props.caseDetailsData?.applicationReview}
        />
        <div className="flex space-x-48 w-1/2"></div>
        <br />
        <Card>
        <Typography.Text style={{ fontSize: '20px' }}>Transaction Summary</Typography.Text>
          <TransactionsLite data={props.transactionData} />
          <br />
          <Typography.Text style={{ fontSize: '20px' }}>Activity Log</Typography.Text>
          <ActivityLogLite data={props.activityData} />
        </Card>
      </div>
    </div>
  );
};
